import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SendToFriendModal from 'dibs-send-to-friend-modal';

// Components
import AddNoteModal from './AddNoteModal';
import ClickToConfirmModal from './ClickToConfirmModal';
import ErrorSuccessContainer from './ErrorSuccessContainer';
import PortfolioCreationModal from './PortfolioCreationModal';

// Helpers
import actions from '../../actions/FavoritesActions';
import { copy, modals, mutations, tabs } from '../../constants';

const Modals = props => {
    const { ERROR, LOADING, NULL, SUCCESS, COMPLETE } = mutations.responses;
    const responses = [COMPLETE, ERROR, LOADING, NULL, SUCCESS];

    if (responses.indexOf(props.mutationResponse) !== -1 && props.showErrorSuccessModal) {
        return (
            <ErrorSuccessContainer
                modalOpen={props.modalOpen}
                mutationResponse={props.mutationResponse}
                openModalType={props.openModalType}
            />
        );
    } else if (
        props.openModalType === modals.REMOVE_FOLDERS ||
        props.openModalType === modals.REMOVE_ITEMS ||
        props.openModalType === modals.REMOVE_FOLLOWING
    ) {
        return (
            <ClickToConfirmModal
                closeModal={() => props.setModalOpen(false)}
                modalOpen={props.modalOpen}
                itemMutations={() => props.itemMutations({ action: mutations.types.REMOVE })}
                folderMutations={() => props.folderMutations({ action: mutations.types.REMOVE })}
                followingMutations={() =>
                    props.followingMutations({ action: mutations.types.REMOVE })
                }
            />
        );
    } else if (
        props.openModalType === modals.SHARE_FOLDER ||
        props.openModalType === modals.SHARE_ITEMS
    ) {
        const type = props.openModalType === modals.SHARE_FOLDER ? tabs.FOLDERS : tabs.ITEMS;

        return (
            <SendToFriendModal
                relay={props.relay}
                viewer={props.viewer}
                modalOpen={props.modalOpen}
                closeModal={() => props.setModalOpen(false)}
                type={type.toUpperCase()}
                selectedItems={props.selectedItems}
                portfolioIds={props.portfolioIds}
                senderEmail={props.userEmail}
                handleMutationResponse={props.handleMutationResponse}
            />
        );
    } else if (props.openModalType === modals.ADD_NOTE) {
        return (
            <AddNoteModal
                modalOpen={props.modalOpen}
                closeModal={() => {
                    props.setModalOpen(false);
                    props.selectItems([]);
                }}
                onClick={(...args) => props.itemMutations(...args)}
                title={copy.addNote.MODAL_TITLE}
                isPublic={props.isPublic}
            />
        );
    } else if (props.openModalType === modals.CREATE_FOLDER) {
        return (
            <PortfolioCreationModal
                closeModal={() => {
                    props.setModalOpen(false);
                    props.setCreateFolderOnLoad(false);
                }}
                title={copy.createFolder.MODAL_TITLE}
                modalOpen={props.modalOpen}
                onClick={(...args) => props.folderMutations(...args)}
            />
        );
    }
    return null;
};

Modals.defaultProps = {
    isPublic: false,
};

Modals.propTypes = {
    relay: PropTypes.object,
    viewer: PropTypes.object,
    folderMutations: PropTypes.func,
    followingMutations: PropTypes.func,
    itemMutations: PropTypes.func,
    handleMutationResponse: PropTypes.func,
    modalOpen: PropTypes.bool,
    mutationResponse: PropTypes.string,
    openModalType: PropTypes.string,
    selectedItems: PropTypes.array,
    portfolioIds: PropTypes.array,
    setModalOpen: PropTypes.func,
    showErrorSuccessModal: PropTypes.bool,
    isPublic: PropTypes.bool,
    userEmail: PropTypes.string,
    setCreateFolderOnLoad: PropTypes.func,
    selectItems: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
    return {
        selectItems: selectedItems => {
            dispatch(actions.selectItems({ selectedItems }));
        },
        setCreateFolderOnLoad: createFolderOnLoad => {
            dispatch(actions.setCreateFolderOnLoad({ createFolderOnLoad }));
        },
        setModalOpen: modalOpen => {
            dispatch(actions.setModalOpen({ modalOpen: modalOpen }));
        },
    };
};

export default connect(
    () => ({}),
    mapDispatchToProps
)(Modals);
